<template>
    <div>
        <el-button v-if="filelist.length == 0" type="primary" @click="xuanzeshipin" size="small"
            style="margin-left: 20px;border-radius: 4px;">选择视频</el-button>
        <el-button v-else type="primary" @click="chongxuanxuanzeshipin" size="small"
            style="margin-left: 20px;">重选视频</el-button>
        <input ref="xzsp" type="file" accept="video/*" id="fileUpload" @change="fileChange($event)" multiple
            style="display: none;">
        <el-button v-if="filelist.length > 0" type="primary" @click="authUpload" :disabled="uploadDisabled" size="small"
            style="margin-left: 20px;">开始上传视频</el-button><span v-if="filelist.length>0" style="margin-left: 10px;font-size: 12px;">已选择{{
                filelist.length }}个视频文件
                <el-tooltip class="item" effect="dark" placement="top" style="font-weight: 600;">
                    <i class="el-icon-paperclip"></i>
                    <div slot="content" v-html="yixuanwenjianming"></div>
                </el-tooltip></span>
         
       

        <el-dialog :show-close="false" :close-on-click-modal="false" title="视频上传中" :visible.sync="spscvisible" width="30%">
            <div>
            <div class="progress" style="margin-left:10px;font-size: 12px;color:#000000" v-if="filelist.length > 0">共{{
                filelist.length }}个视频文件
                <el-tooltip class="item" effect="dark" placement="top" style="font-weight: 600;">
                    <i class="el-icon-paperclip"></i>
                    <div slot="content" v-html="yixuanwenjianming"></div>
                </el-tooltip>
                。{{ scwjm }}上传中：
                <el-progress style="margin-top:10px" :stroke-width="24" :percentage="allauthProgress" status="success"  :text-inside="true"></el-progress></div>
            </div>
        </el-dialog>
        
    </div>
</template>
    <!-- <script src="../../assets/lib/es6-promise.min.js"></script>
    <script src="../../assets/aliyun-oss-sdk-6.17.1.min.js"></script>
    <script src="../../assets/aliyun-upload-sdk-1.5.5.min.js"></script> -->
<script>

import axios from 'axios'
import OSS from '../assets/lib/aliyun-oss-sdk-6.17.1.min'
window.OSS = OSS;
import '../assets/aliyun-upload-sdk-1.5.6.min'
import { shangchuangshipin, shuaxinshangchuanshipin, xierushipinxinxi } from "@/api/api";

export default {
    data() {
        return {
            timeout: '',
            partSize: '',
            parallel: '',
            retryCount: '',
            retryDuration: '',
            region: 'cn-beijing',
            userId: '1549110767342504',
            file: null,
            authProgress: 0,
            uploadDisabled: true,
            resumeDisabled: true,
            pauseDisabled: true,
            uploader: null,
            statusText: '',
            selshipinlist: [],
            filelist: [],
            yixuanwenjianming: '',
            scwjm: "",
            spscvisible: false,
            allauthProgress:0,
            allshipinsize:0,
            readysize:0
        }
    },
    props: {
        in_id: Number,
        collection_id: Number,
        userinfo:Object
    },
    mounted() {
        console.log(this.in_id)
        console.log(this.collection_id)
    },
    watch: {
        selshipinlist(val1, val2) {
            if (val1.length > 0) {
                let yixuanwenjianmingarr = []
                val1.forEach(element => {
                    console.log(element.name)
                    yixuanwenjianmingarr.push(element.name)
                });
                this.yixuanwenjianming = yixuanwenjianmingarr.join('<br/>')
            } else {
                this.yixuanwenjianming = ''
            }
            console.log(this.collection_id)
        }
    },
    methods: {
        chongxuanxuanzeshipin() {
            this.filelist = []
        },
        xuanzeshipin() {
            if(this.userinfo.use_capacity >=this.userinfo.all_capacity){
                this.$message.error('您的空间已不足，请清理空间后再继续上传');
                return false
            }else{
                this.$refs.xzsp.click()
            }
          
        },
        fileChange(e) {
            this.file = e.target.files[0]
            this.filelist = e.target.files
            this.selshipinlist = e.target.files
            if (!this.file) {
                alert("请先选择需要上传的文件!")
                return
            }
            var Title = this.file.name
            var userData = '{"Vod":{}}'
            if (this.uploader) {
                this.uploader.stopUpload()
                this.authProgress = 0
                this.statusText = ""
            }
            this.uploader = this.createUploader()

            for (let i = 0; i < this.filelist.length; i++) {
                this.uploader.addFile(this.filelist[i], null, null, null, userData)
                this.allshipinsize = this.allshipinsize + this.filelist[i].size
                console.log(this.filelist[i])
            }
            this.uploadDisabled = false
            this.pauseDisabled = true
            this.resumeDisabled = true
        },
        authUpload() {
            // 然后调用 startUpload 方法, 开始上传
            if (this.uploader !== null) {
                this.uploader.startUpload()
                this.uploadDisabled = true
                this.pauseDisabled = false
            }
        },
        // 暂停上传
        pauseUpload() {
            if (this.uploader !== null) {
                this.uploader.stopUpload()
                this.resumeDisabled = false
                this.pauseDisabled = true
            }
        },
        // 恢复上传
        resumeUpload() {
            if (this.uploader !== null) {
                this.uploader.startUpload()
                this.resumeDisabled = true
                this.pauseDisabled = false
            }
        },
        createUploader(type) {
            let self = this
            let uploader = new AliyunUpload.Vod({
                timeout: self.timeout || 60000,
                partSize: Math.round(self.partSize || 1048576),
                parallel: self.parallel || 5,
                retryCount: self.retryCount || 3,
                retryDuration: self.retryDuration || 2,
                region: self.region,
                userId: self.userId,
                localCheckpoint: true, //此参数是禁用服务端缓存，不影响断点续传
                // 添加文件成功
                addFileSuccess: function (uploadInfo) {
                    self.uploadDisabled = false
                    self.resumeDisabled = false
                    self.statusText = '添加文件成功, 等待上传...'
                    console.log("addFileSuccess: " + uploadInfo.file.name)
                    console.log(self.allshipinsize)
                },
                // 开始上传
                onUploadstarted: function (uploadInfo) {
                    // 如果是 UploadAuth 上传方式, 需要调用 uploader.setUploadAuthAndAddress 方法
                    // 如果是 UploadAuth 上传方式, 需要根据 uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress
                    // 如果 uploadInfo.videoId 有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
                    // 注意: 这里是测试 demo 所以直接调用了获取 UploadAuth 的测试接口, 用户在使用时需要判断 uploadInfo.videoId 存在与否从而调用 openApi
                    // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)
                    // 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口(https://help.aliyun.com/document_detail/55407.html)
                    if (!uploadInfo.videoId) {
                        //   let createUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/CreateUploadVideo?Title=testvod1&FileName=aa.mp4&BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&VideoId=5bfcc7864fc14b96972842172207c9e6'
                        shangchuangshipin({
                            FileName: uploadInfo.file.name,
                            Title: new Date().getTime(),
                            file_size: uploadInfo.file.size,
                            file_time: uploadInfo.file.lastModified,
                            in_id: self.in_id,
                            collection_id: self.collection_id
                        }).then(res => {
                            // console.log(data)
                            let data = res.data.data
                            let uploadAuth = data.UploadAuth
                            let uploadAddress = data.UploadAddress
                            let videoId = data.VideoId
                            uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, videoId)
                        })
                        self.statusText = '文件开始上传...'
                        self.scwjm = uploadInfo.file.name
                        self.spscvisible = true
                        console.log("onUploadStarted:" + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object)
                    } else {
                        // 如果videoId有值，根据videoId刷新上传凭证
                        // https://help.aliyun.com/document_detail/55408.html?spm=a2c4g.11186623.6.630.BoYYcY
                        //   let refreshUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=' + uploadInfo.videoId
                        //   axios.get(refreshUrl).then(({data}) => {
                        shuaxinshangchuanshipin({
                            videoId: uploadInfo.videoId
                        }).then(res => {
                            let data = res.data.data
                            let uploadAuth = data.UploadAuth
                            let uploadAddress = data.UploadAddress
                            let videoId = data.VideoId
                            uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress, videoId)
                        })
                    }
                },
                // 文件上传成功
                onUploadSucceed: async function (uploadInfo) {
                    console.log("onUploadSucceed: " + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object)
                    self.statusText = '文件上传成功!'
                    console.log(uploadInfo)
                    await xierushipinxinxi({
                        videoid: uploadInfo.videoId
                    })

                },
                // 文件上传失败
                onUploadFailed: function (uploadInfo, code, message) {
                    console.log("onUploadFailed: file:" + uploadInfo.file.name + ",code:" + code + ", message:" + message)
                    self.statusText = '文件上传失败!'
                },
                // 取消文件上传
                onUploadCanceled: function (uploadInfo, code, message) {
                    console.log("Canceled file: " + uploadInfo.file.name + ", code: " + code + ", message:" + message)
                    self.statusText = '文件已暂停上传'
                },
                // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
                onUploadProgress: function (uploadInfo, totalSize, progress) {
                  //console.log("onUploadProgress:file:" + uploadInfo.file.name + ", fileSize:" + totalSize + ", percent:" + Math.ceil(progress * 100) + "%")
                    let progressPercent = Math.ceil(progress * 100)                    
                    self.authProgress = progressPercent
                    self.statusText = uploadInfo.file.name + '上传中...'
                    let readysize = self.readysize
                    readysize =readysize+progress*uploadInfo.file.size                                
                    self.allauthProgress = Math.ceil(readysize/self.allshipinsize * 100)
                    if(Math.ceil(progress * 100) ==100){
                        self.readysize = readysize
                    }      
                },
                // 上传凭证超时
                onUploadTokenExpired: function (uploadInfo) {
                    // 上传大文件超时, 如果是上传方式一即根据 UploadAuth 上传时
                    // 需要根据 uploadInfo.videoId 调用刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)重新获取 UploadAuth
                    // 然后调用 resumeUploadWithAuth 方法, 这里是测试接口, 所以我直接获取了 UploadAuth
                    //  let refreshUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=' + uploadInfo.videoId
                    //   axios.get(refreshUrl).then(({ data }) => {
                    shuaxinshangchuanshipin({
                        videoId: uploadInfo.videoId
                    }).then(res => {
                        let data = res.data.data
                        let uploadAuth = data.UploadAuth
                        uploader.resumeUploadWithAuth(uploadAuth)
                        console.log('upload expired and resume upload with uploadauth ' + uploadAuth)
                    })
                    self.statusText = '文件超时...'
                },
                // 全部文件上传结束
                onUploadEnd: function (uploadInfo) {
                    console.log("onUploadEnd: uploaded all the files")
                    self.filelist = []
                    self.statusText = '文件上传完毕'
                    self.scwjm = ''
                    self.spscvisible = false
                    self.allshipinsize = 0
                    self.allauthProgress = 0
                    self.readysize = 0
                    self.$notify({
                        title: '上传视频',
                        message: '视频上传完毕',
                        type: 'success'
                    });
                }
            })
            return uploader
        }
    }
}
</script>